// Public website tag ID, confirmed in the 2026-11-02 X Events Manager review.
// Conversion event IDs must come from Events Manager; never derive or invent them.
export const X_PIXEL_ID = 'ri7yw';
export const X_REGISTRATION_RECEIPT_PREFIX = 'dobidobi.x-registration.v1:';
type XTag = ((...args: unknown[]) => void) & { queue: IArguments[]; version: string; exe?: (...args: unknown[]) => void };
type PixelWindow = Window & { twq?: XTag; __dobiXPixelConfigured?: boolean };

/** Base tag records one real document arrival. QA/dev never sends X traffic. */
export function initializeXPixel(): void {
  try { installXPixel(); }
  catch { /* Optional third-party telemetry must not interrupt first-party capture or navigation. */ }
}

function installXPixel(): void {
  if (!canTrackXPixel()) return;
  const target = window as PixelWindow;
  if (target.__dobiXPixelConfigured) return;
  if (!target.twq) {
    const tag: XTag = Object.assign(function () {
      if (tag.exe) tag.exe.apply(tag, Array.from(arguments));
      else tag.queue.push(arguments);
    }, { queue: [] as IArguments[], version: '1.1' });
    target.twq = tag;
    const script = document.createElement('script');
    script.id = 'dobidobi-x-pixel';
    script.async = true;
    script.src = 'https://static.ads-twitter.com/uwt.js';
    script.onerror = () => {
      script.remove();
      target.__dobiXPixelConfigured = false;
      delete target.twq;
    };
    document.head.appendChild(script);
  }
  target.twq('set', { hide_page_location: true });
  target.twq('config', X_PIXEL_ID);
  target.__dobiXPixelConfigured = true;
}

export function canTrackXPixel(): boolean {
  return !(typeof window === 'undefined' || process.env.NODE_ENV !== 'production'
    || window.location.hostname !== 'www.dobidobi.ai'
    || window.location.pathname.startsWith('/admin')
    || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl
    || navigator.doNotTrack === '1');
}

/** Save before auth returns: a Pages-to-App document navigation may precede chunk loading. */
export function stageXRegistrationReceipt(owner: string, nonce: string): void {
  try {
    if (!canTrackXPixel() || !owner || !/^[0-9a-f]{32}$/.test(nonce)) return;
    const query = new URLSearchParams(window.location.search);
    if (query.get('utm_source') === 'qa' || query.get('utm_medium') === 'validation') return;
    window.localStorage.setItem(X_REGISTRATION_RECEIPT_PREFIX + owner,
      JSON.stringify({ nonce, createdAt: Date.now() }));
  } catch { /* Storage restrictions never interrupt authentication. */ }
}
